// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchIfpApps, copyApp } from 'client/actions/ifpApps';
import Translate from 'client/components/translate';
import LinkButton from 'client/components/button/linkButton';
import InputZip from 'client/components/form/inputZip';
import ROUTE from 'client/constants/routes';
import type { UserType } from 'web-core/types/user';


const ContinueButton = ({ url }) => (
  <LinkButton href={url} className="cta-button continue primary oep-hover">
    <Translate path="common.cta.continue" />
  </LinkButton>
);

const ViewPlanButton = ({ url }) => (
  <LinkButton href={url} className="cta-button view-dashboard primary oep-hover">
    <Translate path="common.cta.viewDashboard" />
  </LinkButton>
);

const mapStateToProps: Object = (state) => {
  const { user, ifpApps } = state;
  const working_app_id = _.get(user, 'working_app_id') || _.get(user, 'workingAppId');
  const workingApp = working_app_id ? _.find(ifpApps, { app_id: working_app_id }) : {};
  return {
    workingApp,
    user,
    ifpAppsLength: ifpApps.length,
    phase3Enabled: state.phase3Enabled,
  };
};

type Props = {
  copyApp: Function,
  fetchIfpApps: Function,
  id: string,
  ifpAppsLength: number,
  user: {
    ...$Exact<UserType>,
    working_app_id: string,
  } | null,
  workingApp: Object,
  onClick: Function,
  phase3Enabled: boolean,
  extraParams: Object,
};

type State = {
  pending: boolean,
};

const PRE_REGISTER_URL = 'https://get.stridehealth.com/oep20-preregistration';

class HealthEntryPoint extends Component<Props, State> {
  static defaultProps = {
    copyApp: () => {},
    fetchIfpApps: () => {},
    id: 'zip-input',
    ifpAppsLength: 0,
    onClick: () => {},
    user: null,
    workingApp: {},
    extraParams: {},
  };
  constructor(props) {
    super(props);

    this.state = {
      pending: true,
    };

    const now = new Date();
    const year = now.getFullYear();
    this.targetPlanYear = now.getMonth() >= 10 ? year + 1 : year;
    this.isCCAStart = now > new Date(2019, 9, 15); // monthIndex 9: October
    this.isEDEStart = now > new Date(2019, 10, 1);
  }

  UNSAFE_componentWillMount() {
    const { user } = this.props;
    if (user) {
      this.props.fetchIfpApps().then(() => this.setState({ pending: false }));
    } else {
      this.setState({ pending: false });
    }
  }
  targetPlanYear;
  isCCAStart;
  isEDEStart;
  zipSubmitHandler = (value) => {
    const { onClick, workingApp, extraParams } = this.props;

    const urlParams = new URLSearchParams({
      zipcode: value,
      ...extraParams,
    });
    const url = `${ROUTE.HEALTH_PROFILE_LOCATION_PATH}/zipcode?${urlParams.toString()}`;

    onClick(value);

    if (!workingApp || !workingApp.submitted_on) {
      if (this.isCCAStart && !this.isEDEStart) {
        const isCaZipcode = _.inRange(+value, 90001, 96162);
        window.location.href = isCaZipcode ? url : PRE_REGISTER_URL;
      } else {
        window.location.href = url;
      }
    } else {
      this.props.copyApp(workingApp.app_id).then(() => {
        window.location.href = url;
      });
    }
  };

  renderButtonContent() {
    return (
      <span style={{ padding: '0 1rem' }}>
        <Translate path="common.cta.findPlan" className="show-for-medium-up" />
        <span style={{ fontSize: '1.5rem' }} className="icon-search show-for-small-only" />
      </span>
    );
  }

  renderZipInput() {
    return (
      <InputZip
        id={this.props.id}
        submitHandler={this.zipSubmitHandler}
        className="focus-white-color"
        label={{ path: 'common.label.enterZipCode' }}
        buttonClassName="primary oep-hover"
        buttonStyle={{ width: 'auto' }}
        buttonContents={this.renderButtonContent()}
        sideButton />
    );
  }

  render() {
    if (this.state.pending) {
      return null;
    }

    const {
      workingApp: { submitted_on, members, app_json },
      ifpAppsLength,
    } = this.props;

    const planYear = _.get(app_json, 'plan.planYear', 0);

    /* Scenarios:
    (1) If user has submitted app, show either view plan or Zip for next year
    (2) If user has previous year plan and is working on new plan, the outcome
    depends on whether or not zip has valid plans:
    (a) If user has previous year plan and enters a zip with no plans yet, show
    zip entry when they return to the home page
    (b) If the user has previous year plan and enters a zip with plans, until
    they either select a plan--or enter a subsidy if they qualify--we always
    show the zip entry because there's no reliable way to show the continue
    button, since members && members.length returns true regardless of valid zip.
    If there is a plan or subsidy selected, we show continue.
    (3) If there's no plan at all, show the zip entry  */
    if (submitted_on) {
      if (this.targetPlanYear > planYear) {
        return this.renderZipInput();
      }
      return (
        <ViewPlanButton
          url={this.props.phase3Enabled ? ROUTE.PHASE3_DASHBOARD_ROUTE : '/my/insurance'} />
      );
    }

    if (
      (ifpAppsLength === 2 && app_json === null) ||
      (app_json && app_json.plan === null && app_json.subsidy === null)
    ) {
      return this.renderZipInput();
    }

    if (members && members.length) {
      return (
        <ContinueButton
          url={this.props.phase3Enabled ? ROUTE.PHASE3_DASHBOARD_ROUTE : '/my/insurance'} />
      );
    }

    return this.renderZipInput();
  }
}

export default connect(mapStateToProps, {
  copyApp,
  fetchIfpApps,
})(HealthEntryPoint);
